export default __webpack_public_path__ + "static/holiday-pops-d521e7422d8e2acbd1d7eabdb5876e9f.jpg";